// extracted by mini-css-extract-plugin
export default {"selectWrapper":"species_select_mobile__selectWrapper--549s","selectName":"species_select_mobile__selectName--jw6k","selectImg":"species_select_mobile__selectImg--jfqb"};